import React from 'react'
import { Link } from 'react-router-dom'
import CardUI from '../../../widgets/layout/CardUI'
import EmptyListUI from '../../../widgets/output/EmptyListUI.js'
import IconButtonUI from '../../../widgets/action/IconButtonUI.js'
import SuperUserHomePageUI from '../../../templates/SuperUserHomePageUI.js'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI.js'
import DisbursementsNavUI from '../../../components/superUser/loanList/DisbursementsNavUI.js'
import './MonthlyDisbursementPage.css'

const MonthlyDisbursementPageUI = ({ context, errorList, monthlyDisbursed, monthlyDisbursedList, onRefreshClick, onPreviousClick, onNextClick, onTypeChange }) =>
  <SuperUserHomePageUI context={context} className='pg_su_disb_mon' topnav='accounts'
    headerText='Disbursements' centered={!monthlyDisbursed && !errorList} dimension='w1000'
    page='disbursements' onTypeChange={onTypeChange}
  >
    {
      !monthlyDisbursed && !errorList &&
      <SpinnerComponentUI />
    }
    {
      monthlyDisbursed &&
      <>
        <LRTableActionsUI location='top'
          left={
            <span className='g_flex_left g_flex_h'>
              <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} label='Refresh' />
              <span className='g_m_left_100 g_large'><b>Disbursements, excluding Receivable Financing</b></span>
            </span>
          }
          right={<span />}
        />

        <DisbursementsNavUI page='monthly' />

        <div className='g_flex_h g_flex_right'>
          <Link to='#' onClick={onPreviousClick}>Previous</Link>
          <span className='g_m_left_100' />
          <Link to='#' onClick={onNextClick}>Next</Link>
        </div>
      </>
    }

    {
      monthlyDisbursed && monthlyDisbursedList.length > 0 &&
      <AccountDisbursementUI monthlyDisbursed={monthlyDisbursed} />
    }
    {
      monthlyDisbursed && monthlyDisbursedList.length === 0 &&
      <div className='g_m_top_50'>
        <EmptyListUI
          context={context}
          createEnabled={false}
          createDisabledMessageLabel='No disbursements yet'
        />
      </div>
    }
  </SuperUserHomePageUI>

const AccountDisbursementUI = ({ monthlyDisbursed }) =>
  <CardUI title={monthlyDisbursed.monthYear} className='g_m_top_100'>
    <table>
      <thead>
        <tr>
          <th />
          <th>Account</th>
          <th>Loan</th>
          <th>Amount</th>
          <th>Percentage</th>
          <th>Date</th>
        </tr>
      </thead>
      <tbody>
        {
          monthlyDisbursed.accountDisbursedList.map((account, i) =>
            <tr className='acc' key={i}>
              <td className='left'>{i + 1}.</td>
              <td className='left g_no_wrap_2'>{account.accountName}</td>
              <td className='left g_no_wrap_2'>{account.loanName}</td>
              <td>{account.currentDisbursedF2}</td>
              <td>{account.currentDisbursedP}</td>
              <td>{account.disbursementDateF1}</td>
            </tr>
          )
        }
        <tr className='foot'>
          <td />
          <td className='left'>Total</td>
          <td />
          <td>{monthlyDisbursed.totalCurrentDisbursedF2}</td>
        </tr>
      </tbody>
    </table>
  </CardUI>

export default MonthlyDisbursementPageUI
